export const CurrencyEnum = [
    { id: 'USD', name: 'USD', symbol:'$' },
    { id: 'EUR', name: 'EUR', symbol:'€' }
];